import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs';
import {LocationStrategy} from '@angular/common';
import {Injectable, Self} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

import {LoggerService} from "../logger.service";
import {DataRequestOptions} from "../../models";
import {BasicDataService} from "../taker/basicData.service";

@Injectable()
export class AdminDataService extends BasicDataService {

    constructor(@Self() protected http: HttpClient,
                protected locationStrategy: LocationStrategy,
                protected logger: LoggerService) {
        super(http, locationStrategy, logger);
    }

    public getAuthorGroups(pollId: number, options: DataRequestOptions): Observable<any> {
        this.logger.log('AdminDataService: getAuthorGroups', pollId);

        const url = this.POLL_SERVICE_URL + 'admin/authorGroups/' + pollId + '/get.json';

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.get<any>(url, {headers: headers});
    }

    public addAssistanceGroup(pollId: number, options: DataRequestOptions): Observable<any> {
        this.logger.log('AdminDataService: addAssistanceGroup');

        const url = this.POLL_SERVICE_URL + 'admin/poll/' + pollId + '/addAssistanceGroup.json';

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.post<any>(url, null, {headers: headers});
    }

    public updatePollOwner(pollId: number, personId: number, options: DataRequestOptions): Observable<any> {
        this.logger.log('AdminDataService: updatePollOwner');

        const url = this.POLL_SERVICE_URL + 'admin/poll/' + pollId + '/updateOwner/' + personId + '.json';

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.post<any>(url, null, {headers: headers});
    }

    public updatePollOwnerByEmail(pollId: number, email: string, options: DataRequestOptions): Observable<any> {
        this.logger.log('AdminDataService: updatePollOwnerByEmail');

        const url = this.POLL_SERVICE_URL + 'admin/poll/' + pollId + '/updateOwnerByEmail/' + email + '.json';

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.post<any>(url, null, {headers: headers});
    }

    public updatePollOwnerAll(data: { fromPersonField: string; fromValue: string; toPersonField: string; toValue: string }, options: DataRequestOptions) {
        this.logger.log('AdminDataService: updatePollOwnerAll');

        const url = this.POLL_SERVICE_URL + 'admin/poll/updatePollsOwnerAll.json';

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.post<any>(url, data, {headers: headers});

    }

    public importPollAsForm(personId: number, includeResponses: boolean, file: any, options: DataRequestOptions) {
        this.logger.log('AdminDataService: importPollAsForm');

        let params = new HttpParams();
        params = params.append('personId', String(personId));
        params = params.append('includeResponses', String(includeResponses));

        let formData:FormData = new FormData();
        formData.append('file', file, file.name);

        const url = this.POLL_SERVICE_URL + 'admin/poll/importAsForm.json';

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.post<any>(url, formData, {headers: headers, params: params});

    }

    public getExportPollUrl(pollId: number, includeResponses: boolean) {
        const url = this.POLL_SERVICE_URL + 'admin/poll/'+pollId+'/export.json?includeResponses=' + includeResponses;
        return url;
    }

    public exportPoll(pollId: number, includeResponses: boolean, options: DataRequestOptions) {

        this.logger.log('AdminDataService: exportPoll');

        let params = new HttpParams();
        params = params.append('includeResponses', String(includeResponses));

        const url = this.POLL_SERVICE_URL + 'admin/poll/'+pollId+'/exportAsFile.json';

        const headers: HttpHeaders = this.dataRequestOptionsToHeaders(options);

        return this.http.get<any>(url, {headers: headers, params: params});

    }
}
